import React from "react";
import { Mail, Send, Share2 } from "lucide-react";

const ArticleHeader = ({ post }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "No date available";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const authorName = post.author || "PrepNexis AI";
  const authorInitial = authorName.charAt(0).toUpperCase();

  return (
    <div className="rounded-md border border-slate-200 bg-white p-5 shadow-sm sm:p-7">
      <header className="mb-6">
        <a
          href={`/blog/category/${post.category}/`}
          className="inline-flex rounded-sm bg-[rgba(126,34,206,0.08)] px-3 py-1 text-xs font-semibold uppercase text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)]"
        >
          {post.category || "PrepNexis Blog"}
        </a>
        <h1 className="mt-4 text-3xl font-extrabold leading-tight text-gray-900 sm:text-4xl lg:text-5xl">
          {post.title}
        </h1>
        <p className="mt-4 text-lg leading-8 text-gray-600">{post.excerpt}</p>
      </header>

      <div className="flex flex-col gap-4 border-y border-slate-100 py-4 text-sm text-gray-500 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap items-center gap-2 font-medium">
          <span>{post.readMins || "N/A"} mins</span>
          <span className="text-slate-300">/</span>
          <time dateTime={post.date}>{formatDate(post.date)}</time>
        </div>
        <div className="flex items-center">
          <span className="grid h-9 w-9 place-items-center rounded-sm bg-[rgba(126,34,206,0.08)] text-sm font-bold text-[rgb(126,34,206)] ring-1 ring-[rgba(126,34,206,0.16)]">
            {authorInitial}
          </span>
          <div className="ml-3">
            <span className="text-gray-700">Written by </span>
            <a
              href={post.authorLink}
              className="font-semibold text-[rgb(126,34,206)] hover:underline"
            >
              {authorName}
            </a>
          </div>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-2 text-gray-500">
        <span className="mr-2 text-xs font-semibold uppercase text-gray-500">
          Share
        </span>
        <a
          href={`https://www.facebook.com/sharer.php?u=${post.shareUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="grid h-9 w-9 place-items-center rounded-sm bg-slate-50 transition hover:bg-[rgba(126,34,206,0.08)] hover:text-[rgb(126,34,206)]"
        >
          <span className="sr-only">Share on Facebook</span>
          <Share2 className="h-4 w-4" aria-hidden="true" />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${post.title}&url=${post.shareUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="grid h-9 w-9 place-items-center rounded-sm bg-slate-50 transition hover:bg-[rgba(126,34,206,0.08)] hover:text-[rgb(126,34,206)]"
        >
          <span className="sr-only">Share on Twitter</span>
          <Send className="h-4 w-4" aria-hidden="true" />
        </a>
        <a
          href={`mailto:?subject=${post.title}&body=${post.shareUrl}`}
          className="grid h-9 w-9 place-items-center rounded-sm bg-slate-50 transition hover:bg-[rgba(126,34,206,0.08)] hover:text-[rgb(126,34,206)]"
        >
          <span className="sr-only">Share by Email</span>
          <Mail className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>

      {post.featuredImage && (
        <div className="mt-6 overflow-hidden rounded-md bg-slate-100">
          <img
            src={`${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`}
            alt={post.title}
            className="max-h-[520px] w-full object-cover shadow-sm"
          />
        </div>
      )}
    </div>
  );
};

export default ArticleHeader;
